import Logo from '../common/logo';
import * as styles from './styles.css';

const Header = ({ id }: { id?: string }) => {
  return (
    <div id={id} className={styles.header}>
      <Logo />
    </div>
  );
};

export default Header;
